import React from 'react';
import styled, { css } from 'styled-components';
import { fontStyle, spacing, themeLight } from '../../../theme/index';
import { Error } from '@styled-icons/material/Error';
export const Message = ({ children, className, error = false, disabled = false, ...rest }) => {
    return (<MessageWrap className={className} {...rest} error={error} disabled={disabled}>
      <Error size={16}/>
      {children}
    </MessageWrap>);
};
export default Message;
const MessageWrap = styled.div `
  ${fontStyle.bodyText.small};
  display: flex;
  align-items: center;
  margin-top: ${spacing.space8};

  svg {
    margin-right: ${spacing.space8};
  }

  ${({ error }) => error &&
    css `
      color: ${({ theme }) => theme.componentColors ? theme.componentColors.alert.error : themeLight.componentColors.alert.error};
    `}

  ${({ disabled }) => disabled &&
    css `
      color: ${({ theme }) => (theme.typography ? theme.typography.disabledText : themeLight.typography.disabledText)};
    `}
`;
